import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONTATOS_AR_CENTRUS, ENDERECO_AR_CENTRUS, USUARIO_WEB_ALTERAR_SENHA_SCHEMA_CENTRUS } from '../../../app.constants';
import { EnderecoSchemaCentrusModel } from '../models/endereco-schema-centrus.model';

@Injectable()
export class EnderecoCentrusService {

  constructor(private httpClient: HttpClient) { }


  getObterEndereco(centrus): Promise<EnderecoSchemaCentrusModel> {
    return this.httpClient
      .get<EnderecoSchemaCentrusModel>(`${ENDERECO_AR_CENTRUS}/${centrus}`)
      .toPromise();
  }

  updateEndereco(enderecoSchemaCentrusModel: EnderecoSchemaCentrusModel) {
    return this.httpClient
      .put(`${ENDERECO_AR_CENTRUS}`, enderecoSchemaCentrusModel)
      .toPromise();
  }


  updateEnderecoContatos(enderecoSchemaCentrusModel: EnderecoSchemaCentrusModel) {
    return this.httpClient
      .put(`${CONTATOS_AR_CENTRUS}`, enderecoSchemaCentrusModel)
      .toPromise();
  }

  updateSenhaUsuarioWeb(cdCentrus: number, sgSenha: string, token) {
    return this.httpClient
      .put(`${USUARIO_WEB_ALTERAR_SENHA_SCHEMA_CENTRUS}/${cdCentrus}`, sgSenha, { headers: new HttpHeaders().set('Authorization', token)})
      .toPromise();
  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/endereco-centrus.service.ts